var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.hideLayout)?_c('navigeation',{ref:"navigeation",on:{"changePanel":_vm.changePanel}}):_vm._e(),_vm._v(" "),_c('keep-alive',{attrs:{"include":_vm.include}},[_c('router-view',{ref:"routerView",on:{"openLogin":_vm.openLogin}})],1),_vm._v(" "),(!_vm.logged && !_vm.hideLayout)?_c('Bottom'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49fed38d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 